/* ============================================================================
   vyrd-app.js — VirtNova Yeast Relief Drops clone, interaction layer
   Vanilla JS, no dependencies. One-time init guard.
   ============================================================================ */
(function(){
"use strict";
if (window.__vyrdInit) return; window.__vyrdInit = true;

const $  = (s,r=document)=>r.querySelector(s);
const $$ = (s,r=document)=>Array.from(r.querySelectorAll(s));
const $any = (...sels)=>{ for(const s of sels){ const el=$(s); if(el) return el; } return null; };
const reduceMotion = window.matchMedia('(prefers-reduced-motion:reduce)').matches;

/* ============================================================================
   UNIVERSAL UI (runs on every page that loads this file, regardless of
   whether a native Shopify product-data block is present). Reveal/counters/
   expandable cards/compare sliders/rails/FAQ/how-to/timeline/gallery/magnetic
   buttons all live here so pages using Shopify's native product/cart blocks
   (or a custom two-axis picker like Gapzy's) still get them — only the
   single-axis bundle/cart logic further below stays gated behind the
   #vyrd-product-data element specific to the vyrd-hero markup.
   Also note: this script is now included from the LAST section on each
   page's template (vyrd-sticky-atc.liquid for the dog-drops page,
   sw-sticky-atc.liquid for Gapzy) so that by the time this code runs, every
   earlier section's markup has already been parsed into the DOM.
   ============================================================================ */

/* REVEAL ON SCROLL */
(function(){
  const io = new IntersectionObserver(es=>{ es.forEach(e=>{ if(e.isIntersecting){ e.target.classList.add('vyrd-in'); io.unobserve(e.target); } }); },{threshold:.12,rootMargin:'0px 0px -8% 0px'});
  $$('.vyrd-reveal').forEach(el=>io.observe(el));
  // Safety net: some preview/embed contexts (e.g. the Shopify theme editor's iframe)
  // can fail to fire IntersectionObserver callbacks reliably, which would otherwise
  // leave content permanently invisible (opacity:0). Force-reveal anything left behind.
  setTimeout(()=>{ $$('.vyrd-reveal:not(.vyrd-in)').forEach(el=>el.classList.add('vyrd-in')); }, 2500);
})();

/* COUNTERS */
(function(){
  const io = new IntersectionObserver(es=>{ es.forEach(e=>{ if(e.isIntersecting){
    const el=e.target, target=+el.getAttribute('data-vyrd-count');
    if(isNaN(target)) return;
    if(reduceMotion){ el.textContent=target; io.unobserve(el); return; }
    const t0=performance.now(), dur=900;
    const tick=t=>{ const p=Math.min(1,(t-t0)/dur); el.textContent=Math.round(target*p); if(p<1) requestAnimationFrame(tick); };
    requestAnimationFrame(tick); io.unobserve(el);
  } }); },{threshold:.6});
  $$('[data-vyrd-count]').forEach(el=>io.observe(el));
})();

/* CONCERN + BENEFIT expandable cards */
$$('.vyrd-concern').forEach(c=>{
  const toggle=()=>{ const open=c.classList.toggle('vyrd-open'); c.setAttribute('aria-expanded',open); };
  c.addEventListener('click',toggle);
  c.addEventListener('keydown',e=>{ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); toggle(); } });
});
$$('.vyrd-benefit-card').forEach(c=>{
  const toggle=()=>{
    const open=c.classList.toggle('vyrd-open'); c.setAttribute('aria-expanded',open);
    const t=$('.vyrd-toggle span',c); if(t) t.textContent = open ? '−' : '+';
  };
  c.addEventListener('click',toggle);
  c.addEventListener('keydown',e=>{ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); toggle(); } });
});

/* COMPARE SLIDERS (routine slider, ear-compare slider, and any future ones) */
$$('.vyrd-compare-slider').forEach(slider=>{
  const handle=$('.vyrd-cs-handle',slider), after=$('.vyrd-cs-after',slider);
  if(!handle || !after) return;
  let val=50, dragging=false;
  function set(v){ val=Math.max(0,Math.min(100,v)); handle.style.left=val+'%'; after.style.clipPath=`inset(0 0 0 ${val}%)`; slider.setAttribute('aria-valuenow',Math.round(val)); }
  function fromEvent(x){ const r=slider.getBoundingClientRect(); set(((x-r.left)/r.width)*100); }
  slider.addEventListener('pointerdown', e=>{ dragging=true; slider.setPointerCapture(e.pointerId); fromEvent(e.clientX); });
  slider.addEventListener('pointermove', e=>{ if(dragging) fromEvent(e.clientX); });
  slider.addEventListener('pointerup', ()=>dragging=false);
  slider.addEventListener('keydown', e=>{ if(e.key==='ArrowLeft') set(val-4); if(e.key==='ArrowRight') set(val+4); if(e.key==='Home') set(0); if(e.key==='End') set(100); });
  set(50);
  if(!reduceMotion){
    const io=new IntersectionObserver(es=>{ es.forEach(e=>{ if(e.isIntersecting){ io.disconnect(); [[35,300],[65,700],[50,1100]].forEach(([v,t])=>setTimeout(()=>set(v),t)); } }); },{threshold:.5});
    io.observe(slider);
  }
});

/* INGREDIENT + STORIES RAIL SCROLL BUTTONS */
function wireRail(railSel, prevSel, nextSel, itemSel){
  const rail=$(railSel); if(!rail) return;
  const step=()=>{ const c=rail.querySelector(itemSel); return c ? c.getBoundingClientRect().width+18 : 300; };
  const p=$(prevSel), n=$(nextSel);
  if(p) p.addEventListener('click',()=>rail.scrollBy({left:-step(),behavior:'smooth'}));
  if(n) n.addEventListener('click',()=>rail.scrollBy({left:step(),behavior:'smooth'}));
}
wireRail('#vyrdIngredientRail','#vyrdIngPrev','#vyrdIngNext','.vyrd-ing-card');
wireRail('#vyrdStoriesRail','#vyrdStoryPrev','#vyrdStoryNext','.vyrd-story');
wireRail('#swStoriesRail','#swStoryPrev','#swStoryNext','.vyrd-story');
wireRail('#swViralRail','#swViralPrev','#swViralNext','.vyrd-story');

/* FAQ accordion + search + open/close all (shared by vyrd- and sw- prefixed markup) */
function wireFaq(ids){
  const list=$(ids.list); if(!list) return;
  $$('.vyrd-faq-item',list).forEach((item,i)=>{
    const btn=$('.vyrd-faq-q',item), ans=$('.vyrd-faq-a',item);
    if(item.classList.contains('vyrd-open') && ans) ans.style.maxHeight = ans.scrollHeight+'px';
    if(btn) btn.addEventListener('click',()=>{
      const open=item.classList.toggle('vyrd-open'); btn.setAttribute('aria-expanded',open);
      ans.style.maxHeight = open ? ans.scrollHeight+'px' : '0';
    });
  });
  window.addEventListener('load',()=>{ $$('.vyrd-faq-item.vyrd-open .vyrd-faq-a',list).forEach(a=>a.style.maxHeight=a.scrollHeight+'px'); });
  const search=$(ids.search), empty=$(ids.empty);
  if(search) search.addEventListener('input',()=>{
    const q=search.value.trim().toLowerCase(); let shown=0;
    $$('.vyrd-faq-item',list).forEach(it=>{ const txt=it.textContent.toLowerCase(); const hit=!q||txt.includes(q); it.classList.toggle('vyrd-hidden',!hit); if(hit) shown++; });
    if(empty) empty.style.display = shown ? 'none' : 'block';
  });
  const openAll=$(ids.openAll), closeAll=$(ids.closeAll);
  if(openAll) openAll.addEventListener('click',()=>$$('.vyrd-faq-item',list).forEach(it=>{ if(it.classList.contains('vyrd-hidden')) return; it.classList.add('vyrd-open'); $('.vyrd-faq-q',it).setAttribute('aria-expanded','true'); const a=$('.vyrd-faq-a',it); a.style.maxHeight=a.scrollHeight+'px'; }));
  if(closeAll) closeAll.addEventListener('click',()=>$$('.vyrd-faq-item',list).forEach(it=>{ it.classList.remove('vyrd-open'); $('.vyrd-faq-q',it).setAttribute('aria-expanded','false'); $('.vyrd-faq-a',it).style.maxHeight='0'; }));
}
wireFaq({ list:'#vyrdFaqList', search:'#vyrdFaqSearch', empty:'#vyrdFaqEmpty', openAll:'#vyrdFaqOpenAll', closeAll:'#vyrdFaqCloseAll' });
wireFaq({ list:'#swFaqList', search:'#swFaqSearch', empty:'#swFaqEmpty', openAll:'#swFaqOpenAll', closeAll:'#swFaqCloseAll' });

/* HOW-TO scroll-driven animation (matches either vyrd- or sw- prefixed markup) */
(function(){
  const grid=$any('#vyrdHowtoGrid','#swHowtoGrid'); if(!grid) return;
  const steps=$$('.vyrd-howstep',grid), fill=$('.vyrd-fill',grid);
  function play(){ steps.forEach((s,i)=>setTimeout(()=>s.classList.add('vyrd-on'), reduceMotion?0:i*350)); if(fill) setTimeout(()=>fill.style.width='100%', reduceMotion?0:200); }
  function reset(){ steps.forEach(s=>s.classList.remove('vyrd-on')); if(fill) fill.style.width='0'; }
  let loopTimer=null;
  function startLoop(){ if(loopTimer) return; play(); if(!reduceMotion){ loopTimer=setInterval(()=>{ reset(); setTimeout(play,80); },5000); } }
  function stopLoop(){ if(loopTimer){ clearInterval(loopTimer); loopTimer=null; } }
  const io=new IntersectionObserver(es=>{ es.forEach(e=>{ if(e.isIntersecting) startLoop(); else stopLoop(); }); },{threshold:.4});
  io.observe(grid);
})();

/* TIMELINE fill animation (matches either vyrd- or sw- prefixed markup) */
(function(){
  const t=$any('#vyrdExpectTimeline','#swExpectTimeline'); if(!t) return;
  const io=new IntersectionObserver(es=>{ es.forEach(e=>{ if(e.isIntersecting){
    $$('.vyrd-tl-fill',e.target).forEach((f,i)=>setTimeout(()=>f.style.width=(60+i*12)+'%', reduceMotion?0:i*200));
    io.disconnect();
  } }); },{threshold:.4});
  io.observe(t);
})();

/* GALLERY (main image + thumbnail rail + lightbox) — used by both vyrd-hero and sw-hero */
(function(){
  const frame = $('#vyrdGalFrame'), thumbs = $('#vyrdGalThumbs');
  if(!frame) return;
  const slides = $$('.vyrd-gal-slide', frame);
  const thumbEls = $$('.vyrd-gal-thumb', thumbs);
  let idx = 0;
  const mmodal = $('#vyrdMmodal'), mmMedia = $('#vyrdMmMedia');
  function syncModal(){
    if(!mmMedia || !slides[idx]) return;
    mmMedia.className = 'vyrd-media' + (idx===0 ? ' vyrd-spotlight' : '');
    mmMedia.innerHTML = slides[idx].innerHTML;
  }
  function go(i){
    idx = (i + slides.length) % slides.length;
    slides.forEach((s,k)=>s.classList.toggle('vyrd-active', k===idx));
    thumbEls.forEach((t,k)=>{ t.classList.toggle('vyrd-active', k===idx); t.setAttribute('aria-selected', k===idx); });
    if(mmodal && mmodal.classList.contains('vyrd-open')) syncModal();
  }
  thumbEls.forEach((t,i)=>t.addEventListener('click',()=>go(i)));
  const prevBtn=$('#vyrdGalPrev'), nextBtn=$('#vyrdGalNext');
  if(prevBtn) prevBtn.addEventListener('click',()=>go(idx-1));
  if(nextBtn) nextBtn.addEventListener('click',()=>go(idx+1));
  frame.setAttribute('tabindex','0');
  frame.addEventListener('keydown', e=>{ if(e.key==='ArrowLeft') go(idx-1); if(e.key==='ArrowRight') go(idx+1); });
  let sx=null;
  frame.addEventListener('touchstart', e=>{ sx=e.touches[0].clientX; }, {passive:true});
  frame.addEventListener('touchend', e=>{ if(sx==null) return; const dx=e.changedTouches[0].clientX-sx; if(Math.abs(dx)>40) go(idx + (dx<0?1:-1)); sx=null; }, {passive:true});

  /* Media modal (lightbox) */
  const expandBtn = $('#vyrdGalExpand');
  function openModal(){
    if(!mmodal) return;
    syncModal();
    mmodal.classList.add('vyrd-open');
    document.body.classList.add('vyrd-no-scroll');
    const closeBtn = $('#vyrdMmClose'); if(closeBtn) closeBtn.focus();
  }
  function closeModal(){
    if(!mmodal) return;
    mmodal.classList.remove('vyrd-open');
    document.body.classList.remove('vyrd-no-scroll');
    if(expandBtn) expandBtn.focus();
  }
  if(expandBtn) expandBtn.addEventListener('click', openModal);
  if(mmodal){
    const mmClose=$('#vyrdMmClose'), mmPrev=$('#vyrdMmPrev'), mmNext=$('#vyrdMmNext');
    if(mmClose) mmClose.addEventListener('click', closeModal);
    if(mmPrev) mmPrev.addEventListener('click', ()=>go(idx-1));
    if(mmNext) mmNext.addEventListener('click', ()=>go(idx+1));
    mmodal.addEventListener('click', e=>{ if(e.target===mmodal) closeModal(); });
    document.addEventListener('keydown', e=>{ if(e.key==='Escape' && mmodal.classList.contains('vyrd-open')) closeModal(); });
    let mx=null;
    mmMedia.addEventListener('touchstart', e=>{ mx=e.touches[0].clientX; }, {passive:true});
    mmMedia.addEventListener('touchend', e=>{ if(mx==null) return; const dx=e.changedTouches[0].clientX-mx; if(Math.abs(dx)>44) go(idx + (dx<0?1:-1)); mx=null; }, {passive:true});
  }

  // particles
  $$('.vyrd-particles').forEach(p=>{
    if(p.childElementCount) return;
    for(let i=0;i<10;i++){
      const s=document.createElement('i');
      s.style.left=(Math.random()*100)+'%'; s.style.top=(Math.random()*100)+'%';
      s.style.animationDelay=(Math.random()*6)+'s'; s.style.animationDuration=(7+Math.random()*5)+'s';
      p.appendChild(s);
    }
  });
})();

/* MAGNETIC BUTTONS + RIPPLE */
if(!reduceMotion && matchMedia('(hover:hover)').matches){
  $$('.vyrd-magnetic').forEach(btn=>{
    btn.addEventListener('pointermove', e=>{
      const r=btn.getBoundingClientRect();
      const x=(e.clientX-r.left-r.width/2)/r.width, y=(e.clientY-r.top-r.height/2)/r.height;
      requestAnimationFrame(()=>btn.style.transform=`translate(${x*7}px,${y*7}px)`);
    });
    btn.addEventListener('pointerleave', ()=>btn.style.transform='');
  });
}
$$('.vyrd-btn-primary').forEach(btn=>btn.addEventListener('click', function(e){
  const r=this.getBoundingClientRect(), rp=document.createElement('span'); rp.className='vyrd-ripple';
  const size=Math.max(r.width,r.height); rp.style.width=rp.style.height=size+'px';
  rp.style.left=(e.clientX-r.left-size/2)+'px'; rp.style.top=(e.clientY-r.top-size/2)+'px';
  this.appendChild(rp); setTimeout(()=>rp.remove(),600);
}));

/* GENERIC SMOOTH-SCROLL-TO (data-vyrd-scroll-to="#targetId") — used by CTA buttons
   whose href is a same-page anchor as a no-JS fallback. On Shopify OS 2.0 JSON
   templates, the section wrapper's real DOM id is auto-prefixed per template
   (e.g. "shopify-section-template--123__main"), NOT the plain "shopify-section-main"
   the JSON section key would suggest — so href="#shopify-section-main"-style anchors
   silently match nothing and just... do nothing when clicked. Driving the scroll here
   against a literal, JS-controlled id (like #heroBuy) sidesteps that entirely. */
$$('[data-vyrd-scroll-to]').forEach(a=>{
  a.addEventListener('click', e=>{
    const target = $(a.getAttribute('data-vyrd-scroll-to'));
    if(!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  });
});

/* ============================================================================
   SW TWO-AXIS PICKER (color x bundle-qty) — Gapzy's own product/cart wiring.
   Fully independent from the #vyrd-product-data path below: keyed to its own
   #sw-product-data element, so it can never affect the single-axis Yeast
   Relief Drops bundle logic, and vice versa.
   ============================================================================ */
(function(){
  const swDataEl = document.getElementById('sw-product-data');
  if (!swDataEl) return;
  let SWDATA;
  try { SWDATA = JSON.parse(swDataEl.textContent); } catch(e){ console.warn('[sw] bad product data', e); return; }
  const swMoney = n => new Intl.NumberFormat('en-US',{style:'currency',currency:SWDATA.currency||'USD'}).format(n);

  const colors = [...new Set(SWDATA.variants.map(v=>v.color))];
  const qtys = [...new Set(SWDATA.variants.map(v=>v.qty))].sort((a,b)=>a-b);
  const popular = SWDATA.variants.find(v=>v.badge==='Most Popular');
  const SWSTATE = { color: colors[0], qty: popular ? popular.qty : (qtys[0] || 1) };

  function swVariantFor(color, qty){ return SWDATA.variants.find(v=>v.color===color && v.qty===qty); }
  function swReferencePrice(color, qty){
    const base = swVariantFor(color, 1);
    return base ? base.price * qty : null;
  }
  function swCalc(){
    const v = swVariantFor(SWSTATE.color, SWSTATE.qty) || SWDATA.variants[0];
    if(!v) return null;
    const ref = swReferencePrice(SWSTATE.color, v.qty);
    const compare = (ref && ref > v.price) ? ref : v.price;
    return { id:v.id, qty:v.qty, bundleTitle:v.bundleTitle, badge:v.badge, price:v.price, compare:compare, savings:Math.max(0, compare-v.price), perUnit:v.price/v.qty };
  }

  function swBuildBundles(container){
    container.innerHTML='';
    qtys.forEach(qty=>{
      const v = swVariantFor(SWSTATE.color, qty); if(!v) return;
      const ref = swReferencePrice(SWSTATE.color, qty);
      const compare = (ref && ref > v.price) ? ref : v.price;
      const savings = Math.max(0, compare - v.price);
      const perUnit = v.price / qty;
      const label = document.createElement('label');
      label.className = 'vyrd-bundle' + (qty===SWSTATE.qty ? ' vyrd-selected' : '');
      label.setAttribute('data-qty', qty);
      label.setAttribute('role','radio'); label.setAttribute('aria-checked', qty===SWSTATE.qty); label.setAttribute('tabindex','0');
      label.innerHTML = `
        <input type="radio" name="sw-bundle" value="${qty}" ${qty===SWSTATE.qty?'checked':''}>
        <span class="vyrd-radio" aria-hidden="true"></span>
        <span class="vyrd-b-body">
          <span class="vyrd-b-qty">${v.bundleTitle}${v.badge?`<span class="vyrd-badge${qty===3?' vyrd-value':''}">${v.badge}</span>`:''}</span>
          ${savings>0?`<span class="vyrd-save-pill">Save ${swMoney(savings)}</span>`:''}
        </span>
        <span class="vyrd-b-price">
          <span class="vyrd-b-now">${swMoney(v.price)}</span><br>
          ${savings>0?`<span class="vyrd-b-was">${swMoney(compare)}</span>`:''}
          <span class="vyrd-b-each">${swMoney(perUnit)}/brush</span>
        </span>`;
      label.addEventListener('click', ()=>{ SWSTATE.qty=qty; swSyncAll(); });
      label.addEventListener('keydown', e=>{ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); SWSTATE.qty=qty; swSyncAll(); } });
      container.appendChild(label);
    });
  }

  function swRenderSummary(container){
    const d = swCalc(); if(!d) return;
    let rows = `<div class="vyrd-row"><span>${d.qty} Brush${d.qty>1?'es':''} · ${SWSTATE.color}</span><span class="vyrd-num">${swMoney(d.price)}</span></div>`;
    if(d.savings>0){
      rows += `<div class="vyrd-row"><span>Compare-at</span><span class="vyrd-num" style="text-decoration:line-through">${swMoney(d.compare)}</span></div>
      <div class="vyrd-row vyrd-save"><span>You save</span><span class="vyrd-num">${swMoney(d.savings)}</span></div>`;
    }
    rows += `<div class="vyrd-row"><span>Price per brush</span><span class="vyrd-num">${swMoney(d.perUnit)}</span></div>
      <div class="vyrd-row vyrd-total"><span>Total</span><span class="vyrd-num">${swMoney(d.price)}</span></div>`;
    container.innerHTML = rows;
  }

  function swSyncAll(){
    $$('[data-sw-colors] .sw-swatch').forEach(sw=>{ sw.classList.toggle('sw-selected', sw.getAttribute('data-color')===SWSTATE.color); });
    $$('[data-sw-bundles]').forEach(swBuildBundles);
    $$('[data-sw-summary]').forEach(swRenderSummary);
    const d = swCalc();
    if(d) $$('[data-sw-variant-input]').forEach(el=>{ el.value = d.id; });
    if(d) $$('[data-sw-buybar-meta]').forEach(el=>{ el.innerHTML = `${d.qty} Brush${d.qty>1?'es':''} · ${SWSTATE.color} · <strong>${swMoney(d.price)}</strong>`; });
  }

  $$('[data-sw-colors] .sw-swatch').forEach(sw=>{
    sw.addEventListener('click', ()=>{ SWSTATE.color = sw.getAttribute('data-color'); swSyncAll(); });
  });

  swSyncAll();

  $$('[data-sw-add-to-cart]').forEach(btn=>{
    btn.addEventListener('click', ()=>{
      if(btn.classList.contains('vyrd-is-loading')) return;
      const d = swCalc(); if(!d) return;
      const m = String(d.id).match(/(\d+)$/); const variantId = m ? m[1] : d.id;
      btn.classList.add('vyrd-is-loading');
      fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method:'POST',
        headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
        body: JSON.stringify({ items:[{ id: variantId, quantity: 1 }] })
      }).then(res=>{
        if(!res.ok) throw new Error('add-to-cart failed');
        return res.json();
      }).then(cartJson=>{
        btn.classList.remove('vyrd-is-loading');
        // Dispatch the theme's own 'cart:update' event (Horizon's ThemeEvents.cartUpdate).
        // cart-items-component listens for this exact event name; since we don't have
        // rendered section HTML to hand it, it falls back to re-fetching + morphing the
        // section itself via sectionRenderer.renderSection(). cart-drawer-component also
        // listens for this same event name to auto-open. Using generic/made-up event names
        // here (as a previous version of this code did) silently no-ops on this theme —
        // the item gets added to the real cart, but the drawer UI never refreshes to show it.
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cartJson, sourceId: 'sw-add-to-cart', data: { itemCount: cartJson.item_count } }
        }));
        if (window.theme && typeof window.theme.openCartDrawer === 'function') {
          window.theme.openCartDrawer();
        } else {
          const drawer = document.querySelector('cart-drawer-component, cart-drawer, #cart-drawer, .cart-drawer');
          if (drawer && typeof drawer.open === 'function') { drawer.open(); }
          else if (drawer) { drawer.classList.add('active','is-open','open'); }
          else { window.location.href = '/cart'; }
        }
      }).catch(()=>{
        btn.classList.remove('vyrd-is-loading');
        window.location.href = '/cart';
      });
    });
  });
})();

/* ============================================================================
   SW STICKY MOBILE BUY BAR (Gapzy) — shows/hides #swBuybar as the visitor
   scrolls past the hero buy card (#heroBuy) and before the footer. Mirrors the
   dog-drops product's STICKY MOBILE BUY BAR below, but keyed to Gapzy's own
   ids so the two never interfere. Its "Add to Cart" button reuses the shared
   [data-sw-add-to-cart] wiring above (already bound in the loop in the IIFE
   that just closed, since that loop queries the whole document) and its price
   label is kept in sync via the [data-sw-buybar-meta] hook inside swSyncAll().
   ============================================================================ */
(function(){
  const buybar=$('#swBuybar'); if(!buybar) return;
  const heroBuy=$('#heroBuy'), footer=document.querySelector('footer');
  function update(){
    if(!heroBuy) return;
    const heroBottom=heroBuy.getBoundingClientRect().bottom;
    const footerTop = footer ? footer.getBoundingClientRect().top : Infinity;
    const past = heroBottom < 0;
    const beforeFooter = footerTop > window.innerHeight;
    const show = past && beforeFooter && window.innerWidth < 1024;
    buybar.classList.toggle('vyrd-show', show);
    buybar.setAttribute('aria-hidden', show ? 'false' : 'true');
  }
  window.addEventListener('scroll', update, {passive:true});
  window.addEventListener('resize', update, {passive:true});
  update();
})();

/* ============================================================================
   PRODUCT DATA (injected by Liquid as JSON) — everything below this line is
   specific to pages using the custom vyrd-hero bundle/cart markup (single
   color axis). Gapzy uses its own #sw-product-data path above instead.
   ============================================================================ */
const dataEl = document.getElementById('vyrd-product-data');
if (!dataEl) return;
let PRODUCT;
try { PRODUCT = JSON.parse(dataEl.textContent); } catch(e){ console.warn('[vyrd] bad product data', e); return; }
const money = n => new Intl.NumberFormat('en-US',{style:'currency',currency:PRODUCT.currency||'USD'}).format(n);

function qtyFromTitle(title){
  const t=(title||'').toLowerCase();
  if(t.indexOf('three')>-1) return 3;
  if(t.indexOf('two')>-1) return 2;
  return 1;
}
const BUNDLES = (PRODUCT.variants||[]).map(v=>{
  const qty = qtyFromTitle(v.title);
  const price = parseFloat(v.price) || 0;
  const compareRaw = v.compareAtPrice != null ? parseFloat(v.compareAtPrice) : null;
  return {
    id:String(v.id), title:v.title, qty:qty,
    sub: qty===3 ? PRODUCT.subTriple : qty===2 ? PRODUCT.subDouble : PRODUCT.subSingle,
    badge: qty===3 ? 'Best Value' : qty===2 ? 'Most Popular' : null,
    price: price, compare: (compareRaw && compareRaw > price) ? compareRaw : price
  };
});
let defaultBundle = BUNDLES.find(b=>b.badge==='Most Popular') || BUNDLES[0];
const STATE = { bundleId: defaultBundle ? defaultBundle.id : (BUNDLES[0] && BUNDLES[0].id) };

function calc(bundleId){
  const b = BUNDLES.find(x=>x.id===bundleId) || BUNDLES[0];
  if(!b) return null;
  return { id:b.id, qty:b.qty, title:b.title, sub:b.sub, badge:b.badge, price:b.price, compare:b.compare, savings:Math.max(0,b.compare-b.price), perBottle:b.price/b.qty };
}

/* ============================================================================
   BUNDLE CARDS — build + sync across hero + offer modules
   ============================================================================ */
function buildBundles(container){
  container.innerHTML='';
  const mod = container.getAttribute('data-vyrd-bundles');
  BUNDLES.forEach(b=>{
    const d = calc(b.id);
    const label = document.createElement('label');
    label.className='vyrd-bundle'+(b.id===STATE.bundleId?' vyrd-selected':'');
    label.setAttribute('data-bundle-id', b.id);
    label.setAttribute('role','radio'); label.setAttribute('aria-checked', b.id===STATE.bundleId); label.setAttribute('tabindex','0');
    label.innerHTML = `
      <input type="radio" name="vyrd-bundle-${mod}" value="${b.id}" ${b.id===STATE.bundleId?'checked':''}>
      <span class="vyrd-radio" aria-hidden="true"></span>
      <span class="vyrd-b-body">
        <span class="vyrd-b-qty">${b.title}${b.badge?`<span class="vyrd-badge${b.qty===3?' vyrd-value':''}">${b.badge}</span>`:''}</span>
        <span class="vyrd-b-sub">${b.sub||''}</span>
        ${d.savings>0?`<span class="vyrd-save-pill">Save ${money(d.savings)}</span>`:''}
      </span>
      <span class="vyrd-b-price">
        <span class="vyrd-b-now">${money(b.price)}</span><br>
        ${d.savings>0?`<span class="vyrd-b-was">${money(b.compare)}</span>`:''}
        <span class="vyrd-b-each">${money(d.perBottle)}/bottle</span>
      </span>`;
    label.addEventListener('click', ()=>selectBundle(b.id));
    label.addEventListener('keydown', e=>{ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); selectBundle(b.id); } });
    container.appendChild(label);
  });
}
function selectBundle(id){ STATE.bundleId = id; syncAll(); }

function renderSummary(container){
  const d = calc(STATE.bundleId);
  if(!d) return;
  let rows = `
    <div class="vyrd-row"><span>${d.title}</span><span class="vyrd-num" data-num="price">${money(d.price)}</span></div>`;
  if(d.savings>0){
    rows += `<div class="vyrd-row"><span>Compare-at</span><span class="vyrd-num" style="text-decoration:line-through" data-num="compare">${money(d.compare)}</span></div>
    <div class="vyrd-row vyrd-save"><span>You save</span><span class="vyrd-num" data-num="save">${money(d.savings)}</span></div>`;
  }
  rows += `<div class="vyrd-row"><span>Price per bottle</span><span class="vyrd-num" data-num="each">${money(d.perBottle)}</span></div>
    <div class="vyrd-row vyrd-total"><span>Total</span><span class="vyrd-num" data-num="total">${money(d.price)}</span></div>`;
  container.innerHTML = rows;
}

function syncAll(){
  $$('[data-vyrd-bundles]').forEach(container=>{
    $$('.vyrd-bundle',container).forEach(lb=>{
      const on = lb.getAttribute('data-bundle-id')===STATE.bundleId;
      lb.classList.toggle('vyrd-selected',on);
      lb.setAttribute('aria-checked',on);
      const inp=$('input',lb); if(inp) inp.checked=on;
    });
  });
  $$('[data-vyrd-summary]').forEach(s=>{
    const before={}; $$('.vyrd-num',s).forEach(n=>before[n.dataset.num]=n.textContent);
    renderSummary(s);
    $$('.vyrd-num',s).forEach(n=>{ if(before[n.dataset.num]!==undefined && before[n.dataset.num]!==n.textContent){ n.classList.add('vyrd-flash'); setTimeout(()=>n.classList.remove('vyrd-flash'),500); } });
  });
  const d = calc(STATE.bundleId);
  $$('[data-vyrd-buybar-meta]').forEach(el=>{ if(d) el.innerHTML = `${d.title} · <span class="vyrd-num">${money(d.price)}</span>`; });
  // keep the real product form's variant id in sync so native Shopify form / analytics stay correct
  $$('[data-vyrd-variant-input]').forEach(el=>{ el.value = STATE.bundleId; });
}

$$('[data-vyrd-bundles]').forEach(buildBundles);
syncAll();

/* ============================================================================
   ADD TO CART — real Shopify AJAX Cart API
   ============================================================================ */
function extractNumericId(gid){
  if(!gid) return null;
  const m = String(gid).match(/(\d+)$/);
  return m ? m[1] : gid;
}
$$('[data-vyrd-add-to-cart]').forEach(btn=>{
  btn.addEventListener('click', ()=>{
    if(btn.classList.contains('vyrd-is-loading')) return;
    const variantId = extractNumericId(STATE.bundleId);
    if(!variantId) return;
    btn.classList.add('vyrd-is-loading');
    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method:'POST',
      headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
      body: JSON.stringify({ items:[{ id: variantId, quantity: 1 }] })
    }).then(res=>{
      if(!res.ok) throw new Error('add-to-cart failed');
      return res.json();
    }).then(cartJson=>{
      btn.classList.remove('vyrd-is-loading');
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cartJson, sourceId: 'vyrd-add-to-cart', data: { itemCount: cartJson.item_count } }
      }));
      if (window.theme && typeof window.theme.openCartDrawer === 'function') {
        window.theme.openCartDrawer();
      } else {
        const drawer = document.querySelector('cart-drawer-component, cart-drawer, #cart-drawer, .cart-drawer');
        if (drawer && typeof drawer.open === 'function') { drawer.open(); }
        else if (drawer) { drawer.classList.add('active','is-open','open'); }
        else { window.location.href = '/cart'; }
      }
    }).catch(()=>{
      btn.classList.remove('vyrd-is-loading');
      window.location.href = '/cart';
    });
  });
});

/* ============================================================================
   ORAL FLOW animation
   ============================================================================ */
(function(){
  const flow=$('#vyrdOralFlow'); if(!flow) return;
  const nodes=$$('.vyrd-node',flow), arrows=$$('.vyrd-arrow',flow);
  const io=new IntersectionObserver(es=>{ es.forEach(e=>{ if(e.isIntersecting){
    nodes.forEach((n,i)=>setTimeout(()=>n.classList.add('vyrd-on'), reduceMotion?0:i*400));
    arrows.forEach((a,i)=>setTimeout(()=>a.classList.add('vyrd-on'), reduceMotion?0:i*400+200));
    io.disconnect();
  } }); },{threshold:.5});
  io.observe(flow);
})();

/* ============================================================================
   SERVING CALCULATOR
   ============================================================================ */
(function(){
  const cardsWrap=$('#vyrdWeightCards'); if(!cardsWrap) return;
  const body=$('#vyrdServingBody'), liquid=$('#vyrdDropperLiquid'), dropper=$('#vyrdDropper');
  let SERVING = [];
  try { SERVING = JSON.parse(document.getElementById('vyrd-serving-data').textContent); } catch(e){ return; }
  let unit='lb', selected = SERVING[1] ? SERVING[1].key : SERVING[0].key;
  const lbToKg = lb => Math.round(lb*0.4536*10)/10;
  function rangeLabel(s){
    if(unit==='lb') return s.lbLabel;
    if(s.lbMin===0) return `Under ${lbToKg(s.lbMax)} kg`;
    if(s.lbMax===null) return `Over ${lbToKg(s.lbMin)} kg`;
    return `${lbToKg(s.lbMin)} – ${lbToKg(s.lbMax)} kg`;
  }
  function build(){
    cardsWrap.innerHTML='';
    SERVING.forEach(s=>{
      const card=document.createElement('button');
      card.className='vyrd-weight-card'+(s.key===selected?' vyrd-sel':'');
      card.setAttribute('role','radio'); card.setAttribute('aria-checked', s.key===selected);
      card.innerHTML=`<div class="vyrd-wc-range">${rangeLabel(s)}</div><div class="vyrd-wc-hint">${s.ml!=null?`${s.ml} mL · ${s.dropper}`:'Follow the label or ask your vet'}</div>`;
      card.addEventListener('click',()=>{ selected=s.key; build(); result(); });
      cardsWrap.appendChild(card);
    });
  }
  function result(){
    const s=SERVING.find(x=>x.key===selected); if(!s) return;
    if(s.ml==null){
      body.innerHTML=`<div class="vyrd-serving-warn"><strong style="font-family:var(--vyrd-f-display);font-size:22px;color:var(--vyrd-text-light);display:block;margin-bottom:8px">Over 75 lb</strong>Please follow the complete product label or ask your veterinarian for guidance. Do not estimate a serving.</div>`;
      if(liquid) liquid.style.height='0';
      if(dropper) dropper.classList.remove('vyrd-drop');
    } else {
      body.innerHTML=`<div class="vyrd-sr-amt">${s.ml} mL</div><div class="vyrd-sr-sub">${s.dropper}</div>
        <p class="vyrd-sr-note" style="margin-top:16px">Give once daily. Mix with food, treats, or water, or administer directly by mouth. Always follow the serving directions printed on your actual product label.</p>`;
      const pct=Math.min(100,(s.ml/2.5)*100);
      if(liquid) liquid.style.height=pct+'%';
      if(dropper && !reduceMotion) dropper.classList.add('vyrd-drop');
    }
  }
  $$('.vyrd-unit-toggle button').forEach(b=>b.addEventListener('click',()=>{
    unit=b.getAttribute('data-unit');
    $$('.vyrd-unit-toggle button').forEach(x=>x.classList.toggle('vyrd-on',x===b));
    build();
  }));
  const printBtn=$('#vyrdPrintServing'); if(printBtn) printBtn.addEventListener('click',()=>window.print());
  build(); result();
})();

/* ============================================================================
   STICKY MOBILE BUY BAR
   ============================================================================ */
(function(){
  const buybar=$('#vyrdBuybar'); if(!buybar) return;
  const hero=$('#dog-relief-hero'), footer=document.querySelector('footer');
  function update(){
    if(!hero) return;
    const heroBottom=hero.getBoundingClientRect().bottom;
    const footerTop = footer ? footer.getBoundingClientRect().top : Infinity;
    const past = heroBottom < 0;
    const beforeFooter = footerTop > window.innerHeight;
    const show = past && beforeFooter && window.innerWidth < 1024;
    buybar.classList.toggle('vyrd-show', show);
    buybar.setAttribute('aria-hidden', show ? 'false' : 'true');
  }
  window.addEventListener('scroll', update, {passive:true});
  window.addEventListener('resize', update, {passive:true});
  update();
  $$('[data-vyrd-scroll-buy]').forEach(b=>b.addEventListener('click',()=>{
    const target = window.innerWidth<1024 ? $('#dog-relief-offer') : $('#dog-relief-hero');
    if(!target) return;
    const y = target.getBoundingClientRect().top + window.scrollY - 80;
    window.scrollTo({top:y, behavior: reduceMotion?'auto':'smooth'});
  }));
})();

/* ============================================================================
   FINAL CTA mouse-reactive glow
   ============================================================================ */
(function(){
  const glow=$('#vyrdFinalGlow'), sec=$('#dog-relief-final');
  if(!glow || !sec || reduceMotion || !matchMedia('(hover:hover)').matches) return;
  sec.addEventListener('pointermove', e=>{
    const r=sec.getBoundingClientRect();
    const dx=(e.clientX-r.left-r.width/2)*0.06, dy=(e.clientY-r.top-r.height/2)*0.06;
    requestAnimationFrame(()=>{ glow.style.transform = `translate(calc(-50% + ${dx}px), ${dy}px)`; });
  });
})();

})();
